// types
import { Article } from '../@types';

// i18n
import { TFunction } from 'i18next';

// props
export interface GetArticlesParams {
	id?: string;
	t: TFunction;
}

export const getArticles = ({ id, t }: GetArticlesParams): Article[] => {
	const articles: Article[] = [
		{
			categories: ['ACCOUNTS', 'REPORTS', 'SETTINGS', 'TRANSACTIONS'],
			content: [
				`<h3>${t('articles.r3110.1')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r3110.2')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r3110.23')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r3110.24')}</li>`,
				`<li>${t('articles.r3110.25')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r3110.5')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r3110.6')}</li>`,
				`<li>${t('articles.r3110.7')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r3110.8')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r3110.9')}</li>`,
				`<li>${t('articles.r3110.10')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r3110.11')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r3110.12')}</li>`,
				`<li>${t('articles.r3110.13')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r3110.15')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r3110.16')}</li>`,
				`<li>${t('articles.r3110.17')}</li>`,
				`<li>${t('articles.r3110.18')}</li>`,
				`<li>${t('articles.r3110.19')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r3110.20')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r3110.21')}</li>`,
				`<li>${t('articles.r3110.22')}</li>`,
				`<li>${t('articles.r3110.26')}</li>`,
				`<li>${t('articles.r3110.27')}</li>`,
				`</ul>`,
			],
			date: '2026-08-24',
			id: 'r3110',
			img: { alt: t('articles.r3110.title'), src: '/img/articles/revert-inflow.webp' },
			intro: [`<p>${t('articles.r3110.intro')}</p>`],
			release: '3.11.0',
			title: t('articles.r3110.title'),
		},
		{
			categories: ['ACCOUNTS', 'SETTINGS', 'TRANSACTIONS'],
			content: [
				`<h3>${t('articles.r3100.1')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r3100.2')}</li>`,
				`<li>${t('articles.r3100.3')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r3100.4')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r3100.5')}</li>`,
				`<li>${t('articles.r3100.6')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r3100.7')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r3100.8')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r3100.9')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r3100.10')}</li>`,
				`<li>${t('articles.r3100.11')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r3100.12')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r3100.13')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r3100.14')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r3100.15')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r3100.16')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r3100.17')}</li>`,
				`<li>${t('articles.r3100.18')}</li>`,
				`<li>${t('articles.r3100.19')}</li>`,
				`<li>${t('articles.r3100.20')}</li>`,
				`<li>${t('articles.r3100.21')}</li>`,
				`<li>${t('articles.r3100.22')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r3100.23')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r3100.24')}</li>`,
				`<li>${t('articles.r3100.25')}</li>`,
				`<li>${t('articles.r3100.26')}</li>`,
				`<li>${t('articles.r3100.27')}</li>`,
				`<li>${t('articles.r3100.28')}</li>`,
				`<li>${t('articles.r3100.29')}</li>`,
				`<li>${t('articles.r3100.30')}</li>`,
				`<li>${t('articles.r3100.31')}</li>`,
				`<li>${t('articles.r3100.32')}</li>`,
				`</ul>`,
			],
			date: '2026-07-10',
			id: 'r3100',
			img: { alt: t('articles.r3100.title'), src: '' },
			intro: [`<p>${t('articles.r3100.intro')}</p>`],
			release: '3.10.0',
			title: t('articles.r3100.title'),
		},
		{
			categories: ['ACCOUNTS', 'REPORTS', 'SETTINGS', 'TRANSACTIONS'],
			content: [
				`<h3>${t('articles.r390.1')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r390.2')}</li>`,
				`<li>${t('articles.r390.3')}</li>`,
				`<li>${t('articles.r390.4')}</li>`,
				`<li>${t('articles.r390.5')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r390.6')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r390.7')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r390.8')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r390.9')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r390.10')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r390.11')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r390.12')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r390.13')}</li>`,
				`<li>${t('articles.r390.14')}</li>`,
				`<li>${t('articles.r390.15')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r390.16')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r390.17')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r390.18')}</h3>`,
				`<h4>${t('articles.r390.19')}</h4>`,
				`<ul>`,
				`<li>${t('articles.r390.20')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r390.21')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r390.22')}</li>`,
				`<li>${t('articles.r390.23')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r390.24')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r390.25')}</li>`,
				`<li>${t('articles.r390.26')}</li>`,
				`<li>${t('articles.r390.27')}</li>`,
				`<li>${t('articles.r390.28')}</li>`,
				`<li>${t('articles.r390.29')}</li>`,
				`<li>${t('articles.r390.30')}</li>`,
				`<li>${t('articles.r390.31')}</li>`,
				`</ul>`,
			],
			date: '2026-06-12',
			id: 'r390',
			img: { alt: t('articles.r390.title'), src: '' },
			intro: [`<p>${t('articles.r390.intro')}</p>`],
			release: '3.9.0',
			title: t('articles.r390.title'),
		},
		{
			categories: ['REPORTS', 'SETTINGS', 'ACCOUNTS'],
			content: [
				`<h3>${t('articles.r380.1')}</h3>`,
				`<h4>${t('articles.r380.2')}</h4>`,
				`<ul>`,
				`<li>${t('articles.r380.3')}</li>`,
				`<li>${t('articles.r380.4')}</li>`,
				`</ul>`,
				`<h4>${t('articles.r380.5')}</h4>`,
				`<ul>`,
				`<li>${t('articles.r380.6')}</li>`,
				`</ul>`,
				`<h4>${t('articles.r380.7')}</h4>`,
				`<ul>`,
				`<li>${t('articles.r380.8')}</li>`,
				`<li>${t('articles.r380.9')}</li>`,
				`</ul>`,
				`<h4>${t('articles.r380.10')}</h4>`,
				`<ul>`,
				`<li>${t('articles.r380.11')}</li>`,
				`</ul>`,
				`<h4>${t('articles.r380.12')}</h4>`,
				`<ul>`,
				`<li>${t('articles.r380.13')}</li>`,
				`<li>${t('articles.r380.14')}</li>`,
				`</ul>`,
				`<h4>${t('articles.r380.15')}</h4>`,
				`<ul>`,
				`<li>${t('articles.r380.16')}</li>`,
				`<li>${t('articles.r380.17')}</li>`,
				`</ul>`,
				`<h4>${t('articles.r380.18')}</h4>`,
				`<ul>`,
				`<li>${t('articles.r380.19')}</li>`,
				`</ul>`,
				`<h4>${t('articles.r380.20')}</h4>`,
				`<ul>`,
				`<li>${t('articles.r380.21')}</li>`,
				`</ul>`,
				`<h4>${t('articles.r380.22')}</h4>`,
				`<ul>`,
				`<li>${t('articles.r380.23')}</li>`,
				`</ul>`,
				`<h4>${t('articles.r380.24')}</h4>`,
				`<ul>`,
				`<li>${t('articles.r380.25')}</li>`,
				`</ul>`,
				`<h4>${t('articles.r380.26')}</h4>`,
				`<ul>`,
				`<li>${t('articles.r380.27')}</li>`,
				`<li>${t('articles.r380.28')}</li>`,
				`<li>${t('articles.r380.29')}</li>`,
				`</ul>`,
				`<h4>${t('articles.r380.30')}</h4>`,
				`<ul>`,
				`<li>${t('articles.r380.31')}</li>`,
				`<li>${t('articles.r380.32')}</li>`,
				`</ul>`,
				`<h4>${t('articles.r380.33')}</h4>`,
				`<ul>`,
				`<li>${t('articles.r380.34')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r380.35')}</h3>`,
				`<h4>${t('articles.r380.36')}</h4>`,
				`<ul>`,
				`<li>${t('articles.r380.37')}</li>`,
				`<li>${t('articles.r380.38')}</li>`,
				`<li>${t('articles.r380.39')}</li>`,
				`<li>${t('articles.r380.40')}</li>`,
				`<li>${t('articles.r380.41')}</li>`,
				`<li>${t('articles.r380.42')}</li>`,
				`<li>${t('articles.r380.43')}</li>`,
				`<li>${t('articles.r380.44')}</li>`,
				`</ul>`,
				`<h4>${t('articles.r380.45')}</h4>`,
				`<ul>`,
				`<li>${t('articles.r380.46')}</li>`,
				`<li>${t('articles.r380.47')}</li>`,
				`</ul>`,
				`<h4>${t('articles.r380.48')}</h4>`,
				`<ul>`,
				`<li>${t('articles.r380.49')}</li>`,
				`</ul>`,
				`<h4>${t('articles.r380.50')}</h4>`,
				`<ul>`,
				`<li>${t('articles.r380.51')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r380.52')}</h3>`,
				`<h4>${t('articles.r380.53')}</h4>`,
				`<ul>`,
				`<li>${t('articles.r380.54')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r380.55')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r380.56')}</li>`,
				`<li>${t('articles.r380.57')}</li>`,
				`<li>${t('articles.r380.58')}</li>`,
				`<li>${t('articles.r380.59')}</li>`,
				`<li>${t('articles.r380.60')}</li>`,
				`</ul>`,
			],
			date: '2026-04-24',
			id: 'r380',
			img: { alt: t('articles.r380.title'), src: '/img/articles/ifr.webp' },
			intro: [`<p>${t('articles.r380.intro')}</p>`],
			release: '3.8.0',
			title: t('articles.r380.title'),
		},
		{
			categories: ['SETTINGS'],
			content: [
				`<h3>${t('articles.r370.1')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r370.2')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r370.3')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r370.4')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r370.5')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r370.6')}</li>`,
				`<li>${t('articles.r370.7')}</li>`,
				`<li>${t('articles.r370.8')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r370.9')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r370.10')}</li>`,
				`<li>${t('articles.r370.11')}</li>`,
				`</ul>`,
			],
			date: '2026-03-24',
			id: 'r370',
			img: { alt: t('articles.r370.title'), src: '' },
			intro: [`<p>${t('articles.r370.intro')}</p>`],
			release: '3.7.0',
			title: t('articles.r370.title'),
		},
		{
			categories: ['TRANSACTIONS', 'ACCOUNTS'],
			content: [
				`<h3>${t('articles.r360.1')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r360.2')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r360.3')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r360.4')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r360.5')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r360.6')}</li>`,
				`<li>${t('articles.r360.7')}</li>`,
				`<li>${t('articles.r360.8')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r360.9')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r360.10')}</li>`,
				`<li>${t('articles.r360.11')}</li>`,
				`<li>${t('articles.r360.12')}</li>`,
				`<li>${t('articles.r360.13')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r360.14')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r360.15')}</li>`,
				`<li>${t('articles.r360.16')}</li>`,
				`<li>${t('articles.r360.17')}</li>`,
				`<li>${t('articles.r360.18')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r360.19')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r360.20')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r360.21')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r360.22')}</li>`,
				`<li>${t('articles.r360.23')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r360.24')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r360.25')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r360.26')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r360.27')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r360.28')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r360.29')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r360.30')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r360.31')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r360.32')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r360.33')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r360.34')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r360.35')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r360.36')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r360.37')}</li>`,
				`<li>${t('articles.r360.38')}</li>`,
				`<li>${t('articles.r360.39')}</li>`,
				`<li>${t('articles.r360.40')}</li>`,
				`</ul>`,
			],
			date: '2026-03-16',
			id: 'r360',
			img: { alt: t('articles.r360.title'), src: '' },
			intro: [`<p>${t('articles.r360.intro')}</p>`],
			release: '3.6.0',
			title: t('articles.r360.title'),
		},
		{
			categories: ['REPORTS', 'TRANSACTIONS', 'ACCOUNTS'],
			content: [
				`<h3>${t('articles.r350.1')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r350.2')}</li>`,
				`<li>${t('articles.r350.3')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r350.4')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r350.5')}</li>`,
				`<li>${t('articles.r350.6')}</li>`,
				`<li>${t('articles.r350.7')}</li>`,
				`<li>${t('articles.r350.8')}</li>`,
				`<li>${t('articles.r350.9')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r350.10')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r350.11')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r350.12')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r350.13')}</li>`,
				`<li>${t('articles.r350.14')}</li>`,
				`<li>${t('articles.r350.15')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r350.16')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r350.17')}</li>`,
				`<li>${t('articles.r350.18')}</li>`,
				`<li>${t('articles.r350.19')}</li>`,
				`<li>${t('articles.r350.20')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r350.21')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r350.22')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r350.23')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r350.24')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r350.25')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r350.26')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r350.27')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r350.28')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r350.29')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r350.30')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r350.31')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r350.32')}</li>`,
				`<li>${t('articles.r350.33')}</li>`,
				`<li>${t('articles.r350.34')}</li>`,
				`<li>${t('articles.r350.35')}</li>`,
				`<li>${t('articles.r350.36')}</li>`,
				`<li>${t('articles.r350.37')}</li>`,
				`<li>${t('articles.r350.38')}</li>`,
				`</ul>`,
			],
			date: '2026-01-20',
			id: 'r350',
			img: { alt: t('articles.r350.title'), src: '' },
			intro: [`<p>${t('articles.r350.intro')}</p>`],
			release: '3.5.0',
			title: t('articles.r350.title'),
		},
		{
			categories: ['TRANSACTIONS', 'ACCOUNTS'],
			content: [
				`<h3>${t('articles.r340.1')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r340.2')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r340.3')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r340.4')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r340.5')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r340.6')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r340.7')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r340.8')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r340.9')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r340.10')}</li>`,
				`<li>${t('articles.r340.11')}</li>`,
				`</ul>`,
			],
			date: '2025-12-01',
			id: 'r340',
			img: { alt: t('articles.r340.title'), src: '' },
			intro: [`<p>${t('articles.r340.intro')}</p>`],
			release: '3.4.0',
			title: t('articles.r340.title'),
		},
		{
			categories: ['ENTITIES', 'TRANSACTIONS', 'ACCOUNTS'],
			content: [
				`<h3>${t('articles.r330.1')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r330.2')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r330.3')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r330.4')}</li>`,
				`<li>${t('articles.r330.5')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r330.6')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r330.7')}</li>`,
				`<li>${t('articles.r330.8')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r330.9')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r330.10')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r330.11')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r330.12')}</li>`,
				`<li>${t('articles.r330.13')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r330.14')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r330.15')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r330.16')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r330.17')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r330.18')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r330.19')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r330.20')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r330.21')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r330.22')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r330.23')}</li>`,
				`<li>${t('articles.r330.24')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r330.25')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r330.26')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r330.27')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r330.28')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r330.29')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r330.30')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r330.31')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r330.32')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r330.33')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r330.34')}</li>`,
				`<li>${t('articles.r330.35')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r330.36')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r330.37')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r330.38')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r330.39')}</li>`,
				`<li>${t('articles.r330.40')}</li>`,
				`<li>${t('articles.r330.41')}</li>`,
				`<li>${t('articles.r330.42')}</li>`,
				`</ul>`,
			],
			date: '2025-11-21',
			id: 'r330',
			img: { alt: t('articles.r330.title'), src: '' },
			intro: [`<p>${t('articles.r330.intro')}</p>`],
			release: '3.3.0',
			title: t('articles.r330.title'),
		},
		{
			categories: ['TRANSACTIONS', 'REPORTS', 'PROJECTS'],
			content: [
				`<h3>${t('articles.r320.1')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r320.2')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r320.3')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r320.4')}</li>`,
				`<li>${t('articles.r320.5')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r320.6')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r320.7')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r320.8')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r320.9')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r320.10')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r320.11')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r320.12')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r320.13')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r320.14')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r320.15')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r320.16')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r320.17')}</li>`,
				`<li>${t('articles.r320.18')}</li>`,
				`</ul>`,
			],
			date: '2025-10-15',
			id: 'r320',
			img: { alt: t('articles.r320.title'), src: '' },
			intro: [`<p>${t('articles.r320.intro')}</p>`],
			release: '3.2.0',
			title: t('articles.r320.title'),
		},
		{
			categories: ['TRANSACTIONS', 'ACCOUNTS', 'SETTINGS'],
			content: [
				`<h3>${t('articles.r310.1')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r310.2')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r310.3')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r310.4')}</li>`,
				`<li>${t('articles.r310.5')}</li>`,
				`<li>${t('articles.r310.6')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r310.7')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r310.8')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r310.9')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r310.10')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r310.11')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r310.12')}</li>`,
				`<li>${t('articles.r310.13')}</li>`,
				`<li>${t('articles.r310.14')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r310.15')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r310.16')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r310.17')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r310.18')}</li>`,
				`</ul>`,
			],
			date: '2025-09-22',
			id: 'r310',
			img: { alt: t('articles.r310.title'), src: '' },
			intro: [`<p>${t('articles.r310.intro')}</p>`],
			release: '3.1.0',
			title: t('articles.r310.title'),
		},
		{
			categories: ['ENTITIES', 'ACCOUNTS', 'SETTINGS'],
			content: [
				`<h3>${t('articles.r300.1')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r300.2')}</li>`,
				`<li>${t('articles.r300.3')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r300.4')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r300.5')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r300.6')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r300.7')}</li>`,
				`<li>${t('articles.r300.8')}</li>`,
				`<li>${t('articles.r300.9')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r300.10')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r300.11')}</li>`,
				`<li>${t('articles.r300.12')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r300.13')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r300.14')}</li>`,
				`<li>${t('articles.r300.15')}</li>`,
				`<li>${t('articles.r300.16')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r300.17')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r300.18')}</li>`,
				`<li>${t('articles.r300.19')}</li>`,
				`<li>${t('articles.r300.20')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r300.21')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r300.22')}</li>`,
				`<li>${t('articles.r300.23')}</li>`,
				`<li>${t('articles.r300.24')}</li>`,
				`<li>${t('articles.r300.25')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r300.26')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r300.27')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r300.28')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r300.29')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r300.30')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r300.31')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r300.32')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r300.33')}</li>`,
				`<li>${t('articles.r300.34')}</li>`,
				`<li>${t('articles.r300.35')}</li>`,
				`<li>${t('articles.r300.36')}</li>`,
				`</ul>`,
			],
			date: '2025-07-23',
			id: 'r300',
			img: { alt: t('articles.r300.title'), src: '' },
			intro: [`<p>${t('articles.r300.intro')}</p>`],
			release: '3.0.0',
			title: t('articles.r300.title'),
		},
		{
			categories: ['TRANSACTIONS', 'ENTITIES', 'REPORTS'],
			content: [
				`<h3>${t('articles.r230.1')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r230.2')}</li>`,
				`<li>${t('articles.r230.3')}</li>`,
				`<li>${t('articles.r230.4')}</li>`,
				`<li>${t('articles.r230.5')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r230.6')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r230.7')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r230.8')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r230.9')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r230.10')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r230.11')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r230.12')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r230.13')}</li>`,
				`<li>${t('articles.r230.14')}</li>`,
				`<li>${t('articles.r230.15')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r230.16')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r230.17')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r230.18')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r230.19')}</li>`,
				`<li>${t('articles.r230.20')}</li>`,
				`<li>${t('articles.r230.21')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r230.22')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r230.23')}</li>`,
				`<li>${t('articles.r230.24')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r230.25')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r230.26')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r230.27')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r230.28')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r230.29')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r230.30')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r230.31')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r230.32')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r230.33')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r230.34')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r230.35')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r230.36')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r230.37')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r230.38')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r230.39')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r230.40')}</li>`,
				`<li>${t('articles.r230.41')}</li>`,
				`</ul>`,
			],
			date: '2025-05-02',
			id: 'r230',
			img: { alt: t('articles.r230.title'), src: '' },
			intro: [`<p>${t('articles.r230.intro')}</p>`],
			release: '2.3.0',
			title: t('articles.r230.title'),
		},
		{
			categories: ['TRANSACTIONS', 'ACCOUNTS'],
			content: [
				`<h3>${t('articles.r220.1')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r220.2')}</li>`,
				`<li>${t('articles.r220.3')}</li>`,
				`<li>${t('articles.r220.4')}</li>`,
				`<li>${t('articles.r220.5')}</li>`,
				`<li>${t('articles.r220.6')}</li>`,
				`<li>${t('articles.r220.7')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r220.8')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r220.9')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r220.10')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r220.11')}</li>`,
				`<li>${t('articles.r220.12')}</li>`,
				`<li>${t('articles.r220.13')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r220.14')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r220.15')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r220.16')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r220.17')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r220.18')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r220.19')}</li>`,
				`<li>${t('articles.r220.20')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r220.21')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r220.22')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r220.23')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r220.24')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r220.25')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r220.26')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r220.27')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r220.28')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r220.29')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r220.30')}</li>`,
				`<li>${t('articles.r220.31')}</li>`,
				`<li>${t('articles.r220.32')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r220.33')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r220.34')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r220.35')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r220.36')}</li>`,
				`<li>${t('articles.r220.37')}</li>`,
				`</ul>`,
			],
			date: '2025-02-25',
			id: 'r220',
			img: { alt: t('articles.r220.title'), src: '' },
			intro: [`<p>${t('articles.r220.intro')}</p>`],
			release: '2.2.0',
			title: t('articles.r220.title'),
		},
		{
			categories: ['ACCOUNTS', 'TRANSACTIONS'],
			content: [
				`<h3>${t('articles.r210.1')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r210.2')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r210.3')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r210.4')}</li>`,
				`<li>${t('articles.r210.5')}</li>`,
				`<li>${t('articles.r210.6')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r210.7')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r210.8')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r210.9')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r210.10')}</li>`,
				`</ul>`,
			],
			date: '2025-01-09',
			id: 'r210',
			img: { alt: t('articles.r210.title'), src: '' },
			intro: [`<p>${t('articles.r210.intro')}</p>`],
			release: '2.1.0',
			title: t('articles.r210.title'),
		},
		{
			categories: ['ACCOUNTS', 'ENTITIES', 'REPORTS', 'SETTINGS', 'TRANSACTIONS'],
			content: [
				`<h3>${t('articles.r200.1')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r200.2')}</li>`,
				`<li>${t('articles.r200.3')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r200.4')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r200.5')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r200.6')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r200.7')}</li>`,
				`<li>${t('articles.r200.8')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r200.9')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r200.10')}</li>`,
				`<li>${t('articles.r200.11')}</li>`,
				`<li>${t('articles.r200.12')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r200.13')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r200.14')}</li>`,
				`<li>${t('articles.r200.15')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r200.16')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r200.17')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r200.18')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r200.19')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r200.20')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r200.21')}</li>`,
				`<li>${t('articles.r200.22')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r200.23')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r200.24')}</li>`,
				`<li>${t('articles.r200.25')}</li>`,
				`<li>${t('articles.r200.26')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r200.27')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r200.28')}</li>`,
				`<li>${t('articles.r200.29')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r200.30')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r200.31')}</li>`,
				`<li>${t('articles.r200.32')}</li>`,
				`<li>${t('articles.r200.33')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r200.34')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r200.35')}</li>`,
				`<li>${t('articles.r200.36')}</li>`,
				`<li>${t('articles.r200.37')}</li>`,
				`</ul>`,
			],
			date: '2024-12-20',
			id: 'r200',
			img: { alt: t('articles.r200.title'), src: '' },
			intro: [`<p>${t('articles.r200.intro')}</p>`],
			release: '2.0.0',
			title: t('articles.r200.title'),
		},
		{
			categories: ['ACCOUNTS', 'ENTITIES', 'SETTINGS', 'TRANSACTIONS'],
			content: [
				`<h3>${t('articles.r100.1')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r100.2')}</li>`,
				`<li>${t('articles.r100.3')}</li>`,
				`<li>${t('articles.r100.4')}</li>`,
				`<li>${t('articles.r100.5')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r100.6')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r100.7')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r100.8')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r100.9')}</li>`,
				`<li>${t('articles.r100.10')}</li>`,
				`<li>${t('articles.r100.11')}</li>`,
				`<li>${t('articles.r100.12')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r100.13')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r100.14')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r100.15')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r100.16')}</li>`,
				`<li>${t('articles.r100.17')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r100.18')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r100.19')}</li>`,
				`<li>${t('articles.r100.20')}</li>`,
				`<li>${t('articles.r100.21')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r100.22')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r100.23')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r100.24')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r100.25')}</li>`,
				`<li>${t('articles.r100.26')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r100.27')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r100.28')}</li>`,
				`</ul>`,
				`<h3>${t('articles.r100.29')}</h3>`,
				`<ul>`,
				`<li>${t('articles.r100.30')}</li>`,
				`<li>${t('articles.r100.31')}</li>`,
				`<li>${t('articles.r100.32')}</li>`,
				`<li>${t('articles.r100.33')}</li>`,
				`<li>${t('articles.r100.34')}</li>`,
				`<li>${t('articles.r100.35')}</li>`,
				`<li>${t('articles.r100.36')}</li>`,
				`</ul>`,
			],
			date: '2024-11-19',
			id: 'r100',
			img: { alt: t('articles.r100.title'), src: '' },
			intro: [`<p>${t('articles.r100.intro')}</p>`],
			release: '1.0.0',
			title: t('articles.r100.title'),
		},
	];

	if (id) {
		return articles.filter((a) => a.id === id);
	}

	return articles;
};
